"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
var _constants = require("./lib/constants");
class BotsApi extends _basic_data_hub_api.default {
  async deleteBot(bot) {
    let temporarily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return this._callApi({
      path: `/bots/${bot.id}`,
      payload: {
        temporarily
      },
      method: 'delete',
      queryParams: {}
    });
  }
  async recoverBot(bot) {
    let {
      recoverFlows
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      path: `/bots/${bot.id}`,
      method: 'patch',
      payload: {
        recoverFlows
      }
    });
  }
  async getBotById(botId, projection) {
    return this._callApi({
      path: `/bots/${botId}`,
      queryParams: {
        projection
      }
    });
  }
  async getBots(_ref) {
    let {
      query = {},
      projection,
      includeDeleted = false,
      includeExisting = true,
      group,
      limit,
      offset
    } = _ref;
    if (includeDeleted && !includeExisting) query.isDeleted = true;
    if (!includeDeleted && includeExisting) query.isDeleted = false;
    return this._callApi({
      path: `/bots`,
      queryParams: {
        query,
        projection,
        group,
        limit,
        offset
      }
    });
  }
  async getBotsByToken(_ref2) {
    let {
      query = {},
      projection,
      limit,
      token
    } = _ref2;
    const binding = await this.getBinding();
    const method = this._getMethodName('list');
    const accountId = this.accountId;
    return binding.query[method]({
      entity: _constants.BOT,
      params: {
        ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
        queryParams: query,
        limit,
        last: token
      },
      ...(accountId ? {
        accountId
      } : {
        sandbox: false
      })
    }, projection || ['records', 'last']);
  }
  async saveBot(bot) {
    bot.id = bot.id || 'new';
    const res = await this._callApi({
      path: `/bots/${bot.id}`,
      payload: {
        bot
      },
      queryParams: {},
      method: 'post'
    });
    return this.setDiff(bot, res);
  }
  static async getNewBot() {
    return {
      data: {
        label: '',
        description: '',
        longDescription: '',
        iconUrl: '',
        deploy: {}
      }
    };
  }
}
var _default = BotsApi;
exports.default = _default;